// extracted by mini-css-extract-plugin
export var fallback = "_9-0";
export var icon = "_9-1";